const DEFERRED_END_DELAY_MS = 100;

let isActive = false;
let publishEndRef: (() => void) | null = null;
let pendingEndTimer: ReturnType<typeof setTimeout> | null = null;

export const restockingActivityCoordinator = {
  start(publishStart: () => void, publishEnd: () => void) {
    if (pendingEndTimer) {
      clearTimeout(pendingEndTimer);
      pendingEndTimer = null;
    }
    publishEndRef = publishEnd;
    if (isActive) return;
    publishStart();
    isActive = true;
  },

  end(options?: { defer?: boolean }) {
    if (!isActive) return;
    if (pendingEndTimer) clearTimeout(pendingEndTimer);

    const fire = () => {
      publishEndRef?.();
      isActive = false;
      publishEndRef = null;
      pendingEndTimer = null;
    };

    if (options?.defer) {
      pendingEndTimer = setTimeout(fire, DEFERRED_END_DELAY_MS);
      return;
    }

    fire();
  },
};
